import { IWsMessageReply } from '../actions/wsMessage/types';

export const createWsReply = (messageId: string, createdAt: number): IWsMessageReply => ({
  messageId,
  createdAt: new Date(createdAt).toISOString(),
});
